var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHobbies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2547_814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7141 25.8753C23.2004 23.1728 21.2099 18.6413 17.5005 18.6713C13.7784 18.658 11.8038 23.1525 14.287 25.8753C11.0682 27.1569 8.78711 30.3042 8.78711 33.9745C8.78711 34.5408 9.24621 34.9999 9.81249 34.9999H25.1887C25.755 34.9999 26.2141 34.5408 26.2141 33.9745C26.214 30.3043 23.9329 27.157 20.7141 25.8753ZM17.5005 20.7221C18.752 20.7221 19.77 21.7402 19.77 22.9916C19.6559 25.9982 15.3446 25.9974 15.231 22.9916C15.231 21.7401 16.2491 20.7221 17.5005 20.7221ZM10.9166 32.9491C12.2199 25.4796 22.784 25.4849 24.0845 32.9491H10.9166Z",
    fill: "url(#paint0_linear_2547_814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8385 12.0815C29.9908 12.0815 29.1706 12.3408 28.4827 12.8122C27.7947 12.3408 26.9745 12.0815 26.1268 12.0815C23.8325 12.0815 21.9658 13.9492 21.9658 16.2447C21.9658 20.7911 27.8291 23.3564 28.0787 23.4634C28.3366 23.5739 28.6287 23.5739 28.8866 23.4634C29.1362 23.3564 34.9995 20.7911 34.9995 16.2447C34.9996 13.9491 33.1329 12.0815 30.8385 12.0815ZM28.4827 21.3848C20.5847 17.2585 25.0601 12.2258 27.7147 14.8494C27.9093 15.0694 28.1889 15.1954 28.4827 15.1954C28.7764 15.1954 29.0561 15.0694 29.2507 14.8494C31.9049 12.2259 36.3808 17.2579 28.4827 21.3848Z",
    fill: "url(#paint1_linear_2547_814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.034 15.3002C13.034 13.5207 11.4081 12.1848 9.65409 12.5316L7.78236 12.9065C6.45511 13.1719 5.4918 14.347 5.4918 15.7006V21.285C3.05016 19.9824 -0.0372572 21.8588 0.000340077 24.6391C0.189762 29.6349 7.35369 29.6339 7.54256 24.639V19.4391L10.0511 18.9373C11.7795 18.5924 13.034 17.0628 13.034 15.3002ZM3.77142 26.3594C2.8228 26.3594 2.05103 25.5876 2.05103 24.639C2.13751 22.3598 5.4056 22.3604 5.4918 24.639C5.4918 25.5876 4.72003 26.3594 3.77142 26.3594ZM7.54256 17.3476V15.7005C7.54256 15.3211 7.81251 14.9918 8.18452 14.9174L10.0551 14.5427C10.4318 14.4682 10.9833 14.7154 10.9833 15.3002C10.9833 16.0882 10.4224 16.772 9.64938 16.9263L7.54256 17.3476Z",
    fill: "url(#paint2_linear_2547_814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4516 9.63088L17.0414 12.9258C17.3309 13.0702 17.6688 13.0701 17.9585 12.9258L24.5483 9.63088C24.8957 9.45718 25.1151 9.10212 25.1151 8.71371V1.02568C25.1151 0.670282 24.9311 0.340246 24.6288 0.153422C24.3265 -0.0334024 23.949 -0.050287 23.6312 0.10851L17.4999 3.17412L11.3687 0.10851C11.0508 -0.0504237 10.6734 -0.0334707 10.3711 0.153422C10.0688 0.340246 9.88477 0.670282 9.88477 1.02568V8.71378C9.88477 9.10212 10.1042 9.45718 10.4516 9.63088ZM18.5252 4.95425L23.0643 2.68475V8.08002L18.5252 10.3495V4.95425ZM11.9355 2.68475L16.4745 4.95425V10.3495L11.9355 8.07996V2.68475Z",
    fill: "url(#paint3_linear_2547_814)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_814",
    x1: 17.5006,
    y1: 18.6711,
    x2: 17.5006,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2547_814",
    x1: 28.4827,
    y1: 12.0815,
    x2: 28.4827,
    y2: 23.5463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2547_814",
    x1: 6.51701,
    y1: 12.4766,
    x2: 6.51701,
    y2: 28.3856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2547_814",
    x1: 17.4999,
    y1: 0.000244141,
    x2: 17.4999,
    y2: 13.0341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2547_814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbies);
export default __webpack_public_path__ + "static/media/hobbies.a8e32e7f85328ebca2557175e5d380c5.svg";
export { ForwardRef as ReactComponent };